export const REFRESH_FILES = 'REFRESH_FILES';
export const CLEAR_FILES_FILTERS = 'CLEAR_FILES_FILTERS';
export const FILTER_FILES = 'FILTER_FILES';
export const TOGGLE_IS_FAVORITE = 'TOGGLE_IS_FAVORITE';




